import IniciadorAsuntoFormView from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/IniciadorAsuntoFormView'
import SubmitForm from 'src/components/views/EscritosLexnet/components/shared/components/SubmitForm'

type IniciadorAsuntoPropsTyps = {
  section: string
}

function IniciadorAsunto({ section }: IniciadorAsuntoPropsTyps): JSX.Element {
  return (
    <SubmitForm>
      <IniciadorAsuntoFormView section={section} />
    </SubmitForm>
  )
}

export default IniciadorAsunto
